import { ApiClient } from "@bafe/api-client";

import { signInHref } from "./auth-flow.js";
import { useOrganisationStore } from "./stores";

/**
 * Empty base URL means same-origin `/api/...`, which is how the app is served
 * in production and how the dev proxy is wired.
 */
const baseUrl = import.meta.env.VITE_API_BASE_URL ?? "";

/** Reads the organisation chosen in the switcher, for tenant scoping. */
export function getOrganisationId(): string | null {
	return useOrganisationStore.getState().organisationId;
}

function redirectToSignIn(): void {
	if (typeof window === "undefined") return;

	const { pathname, search } = window.location;
	const target = signInHref(pathname, search);
	if (!target) return;
	window.location.assign(target);
}

export const api = new ApiClient({
	baseUrl,
	surface: "manage",
	onUnauthenticated: redirectToSignIn,
	getOrganisationId,
});
